<template>
  <div class="flex gap-4 items-center justify-between">
    <CTableInput
      :always-display-edit-icon="true"
      :class="{ 'w-full max-w-[400px]': getInputState(activeInputId === COLLECTION_NAME_KEY) === 'edit' }"
      :max-length="64"
      :model-value="
        getInputState(activeInputId === COLLECTION_NAME_KEY) === 'view'
          ? collection.name || t('canvasUI.collectionSelector.defaultNewCollectionName')
          : collection.name
      "
      :readonly="readonlyName"
      :state="getInputState(activeInputId === COLLECTION_NAME_KEY)"
      value-class="color-primary font-size-5 line-height-8 tracking-[0.25px]"
      @cancel="clearActiveInput()"
      @edit="setActiveInput(COLLECTION_NAME_KEY)"
      @update:modelValue="updateCollectionName"
    />

    <div class="flex gap-4 items-center justify-between">
      <div class="flex gap-4 items-center">
        <CButton
          v-if="isSettingsButtonVisible"
          v-tooltip="t('canvasUI.collectionSelector.settings')"
          class="control-bar__button"
          strong
          type="secondary"
          @click="openSettings()"
        >
          <template #icon>
            <CIcon class="color-primary3" icon="cog" size="16" />
          </template>
        </CButton>

        <CButton iconPlacement="left" type="primary" @click="addGroup()">
          {{ translations?.createGroup || t('canvasUI.collectionSelector.createGroup') }}

          <template #icon>
            <CIcon icon="plus" size="16" />
          </template>
        </CButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CTableInput from '@lib/components/CTableInput/CTableInput.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useTableInput } from '@collection-selector/composables/table-input.use'
import { useAppStore } from '@collection-selector/stores/app.store'

const COLLECTION_NAME_KEY = 'collectionNameKey'

defineProps<{
  readonlyName?: boolean
}>()

const { t } = useI18n()
const { activeInputId, getInputState, setActiveInput, clearActiveInput } = useTableInput()
const {
  updateCollectionName: updateCollectionNameOperation,
  addGroup,
  openSettings,
  collection,
  translations,
  isSettingsButtonVisible,
} = useAppStore()

const updateCollectionName = (name: string) => {
  updateCollectionNameOperation(name)
  clearActiveInput()
}
</script>
